module.exports = __webpack_public_path__ + "img/ski9.5166c393.png";